import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { WebGameResponseModel } from '../models/web-game-response.model';
import { mapWebGameResponseDtoToWebGameResponseModel } from '../utils/mapping.util';
import { WebGameByIdArgsModel } from './models/web-game-by-id-args.model';

export const getWebGameById: AsyncThunk<
  WebGameResponseModel,
  WebGameByIdArgsModel,
  Record<string, unknown>
> = createAsyncThunk<WebGameResponseModel, WebGameByIdArgsModel>(
  'web-games/get-web-game',
  async ({ gameId }) => {
    const url: string = createPathParams<'id'>(Endpoints.WEB_GAME_BY_ID, {
      id: gameId,
    });
    const { data }: AxiosResponse<WebGameResponseModel> =
      await axiosInstance.get(url);
    return mapWebGameResponseDtoToWebGameResponseModel(data);
  }
);
